/**
 * mwApp.packages module <br>
 * Work with packages (networks): show/add/edit/remove
 *
 * @namespace mwApp/packages
 */

import AddFromCategoryCtrl from './components/shelves/addFromCategory.controller'
import AddSlotsCtrl from './components/shelves/addSlots.controller'
import EditShelvesCtrl from './components/shelves/editShelves.controller'
import EditAiHintsCtrl from './components/aiHints/editAiHints.controller'
import ShelfAccordionCtrl from './components/shelves/shelfAccordion.controller'
import SubscriptionSettingsCtrl from './subscriptionSettings.controller'
import AddPackageCtrl from './addPackage.controller'
import AddReminderCtrl from './addReminder.controller'
import AddSubscriptionSettingsCtrl from './addSubscriptionSettings.controller'
import AnnouncementsCtrl from './announcements.controller'
import PackagesCtrl from './packages.controller'
import SubscriptionAnotherAmountCtrl from './subscriptionAnotherAmount.controller'
import DiscountsCtrl from './discounts.controller'
import { overlapWith } from './packages.directives'
import packagesConfig from './packages.config'
import AddCouponCtrl from './addCoupon.controller'
import ContentSetsCtrl from './contentSets.controller'
import AddVodSetCtrl from './addVodSet.controller'
import AddVodSetSettingsCtrl from './addVodSetSettings.controller'
import SubscriptionContentSetsCtrl from './subscriptionContentSets.controller'
import { AlertLightSvc } from '../common/services/alert.service'
import AddShowSetCtrl from './addShowSet.controller'
import CustomizeClientAppsCtrl from './customizeClientApps.controller'
import FeaturedCarouselCtrl from './featuredCarousel.controller'
import BannerCarouselCtrl from './bannerCarousel.controller'
import AddBannerBundleCtrl from './addBannerBundle.controller'
import AddPushNotificationCtrl from './addPushNotification.controller'
import AddChannelSetCtrl from './addChannelSet.controller'
import SubscriptionChannelListingCtrl from './subscriptionChannelListing.controller'
import AddChannelGroupCtrl from './addChannelGroup.controller'
import AddLiveEventSetCtrl from './addLiveEventSet.controller'
import AddContentSetsCtrl from './addContentSets.controller'
import AddAddonsCtrl from './addAddons.controller'
import EditAddonCtrl from './editAddon.controller'
import ViewContentSetCtrl from './viewContentSet.controller'
import ChannelListingCtrl from './channelListing.controller'
import SettingsCtrl from './settings.controller'
import ShoppingCartSettingsCtrl from './shoppingCartSettings.conttroller'
import NewItemsPriceCtrl from './newItemsPrice.controller'
import ShoppingCartCtrl from './shoppingCart.controller'
import OrganizationLocalizationsCtrl from './organizationLocalizations.controller'
import SetrixServerSettingsCtrl from './setrixServerSettings.controller'
import PaymentServicesCtrl from './paymentServices.controller'
import ContentSetsModalCtrl from './popups/contentSetsModal.controller'
import SubscriptionContentSetsModalCtrl from './popups/subscriptionContentSetsModal.controller'
import ContentItemIntersectionModalCtrl from './popups/contentItemIntersectionModal.controller'
import AddAccessoryCtrl from './addAccessory.controller'
import MonetizationTypeAccessoriesCtrl from './monetizationTypeAccessories.controller'
import { SubscriptionAccessoriesCtrl } from './subscriptionAccessories.controller'
import { AddSubscriptionAccessoriesCtrl } from './addSubscriptionAccessories.controller'
import AddSubscriptionPlanCtrl from './addSubscriptionPlan.controller'
import SubscriptionDiscountSettingsCtrl from './subscriptionDiscountSettings.controller'
import PartnerProductsCtrl from './partnerProducts.controller'
import AddPartnerProductCtrl from './addPartnerProduct.controller'
import AddFreePartnerProductsCtrl from './addFreePartnerProducts.controller'
import AddPaidPartnerProductsCtrl from './addPaidPartnerProducts.controller'
import EditPaidPartnerProductCtrl from './editPaidPartnerProduct.controller'
import SubscriptionPartnerProductsCtrl from './subscriptionPartnerProducts.controller'
import EditShoppingCartSettingsCtrl from './editShoppingCartSettings.controller'
import PromotionCtrl from './promotion.controller'
import AddFeaturedRowItemsCtrl from './addFeaturedRowItems.controller'
import PackageGeneralSettingsCtrl from './packageGeneralSettings.controller'
import AddRowsCtrl from './addRows.controller'
import PreviewCtrl from './appCustomization/Preview/preview.controller'
import DiscountCampaignsCtrl from './discountCampaigns.controller'
import AddDiscountCampaignCtrl from './addDiscountCampaign.controller'
import DiscountCampaignErrorModalCtrl from './popups/discountCampaignErrorModal.controller'
import SubscriptionDiscountCampaignErrorModalCtrl from './popups/subscriptionDiscountCampaignErrorModal.controller'
import ViewPastDiscountCampaignCtrl from './viewPastDiscountCampaign.controller'
import AddMultiSetCtrl from './addMultiSet.controller'
import AddMultiSetItemsCtrl from './addMultiSetItems.controller'
import ModuleConfigurationCtrl from './moduleConfiguration.controller'
import AddModuleSettingsCtrl from './addModuleSettings.controller'
import MenuPreviewCtrl from './appCustomization/MenuPreview/menuPreview.controller'
import AddTermsCtrl from './addTerms.controller'

export default angular.module('mwApp.packages', [])
  .config(packagesConfig)
  .directive('overlapWith', overlapWith)
  .controller('PackagesCtrl', PackagesCtrl)
  .controller('AddPackageCtrl', AddPackageCtrl)
  .controller('SettingsCtrl', SettingsCtrl)
  .controller('EditShelvesCtrl', EditShelvesCtrl)
  .controller('EditAiHintsCtrl', EditAiHintsCtrl)
  .controller('AddFromCategoryCtrl', AddFromCategoryCtrl)
  .controller('ShelfAccordionCtrl', ShelfAccordionCtrl)
  .controller('AddSlotsCtrl', AddSlotsCtrl)
  .controller('PackageGeneralSettingsCtrl', PackageGeneralSettingsCtrl)
  .controller('SubscriptionSettingsCtrl', SubscriptionSettingsCtrl)
  .controller('MonetizationTypeAccessoriesCtrl', MonetizationTypeAccessoriesCtrl)
  .controller('SubscriptionAnotherAmountCtrl', SubscriptionAnotherAmountCtrl)
  .controller('AddSubscriptionSettingsCtrl', AddSubscriptionSettingsCtrl)
  .controller('AddAccessoryCtrl', AddAccessoryCtrl)
  .controller('AnnouncementsCtrl', AnnouncementsCtrl)
  .controller('AddReminderCtrl', AddReminderCtrl)
  .controller('AddPushNotificationCtrl', AddPushNotificationCtrl)
  .controller('DiscountsCtrl', DiscountsCtrl)
  .controller('DiscountCampaignsCtrl', DiscountCampaignsCtrl)
  .controller('AddDiscountCampaignCtrl', AddDiscountCampaignCtrl)
  .controller('ViewPastDiscountCampaignCtrl', ViewPastDiscountCampaignCtrl)
  .controller('AddCouponCtrl', AddCouponCtrl)
  .controller('ContentSetsCtrl', ContentSetsCtrl)
  .controller('AddVodSetCtrl', AddVodSetCtrl)
  .controller('AddVodSetSettingsCtrl', AddVodSetSettingsCtrl)
  .controller('SubscriptionDiscountSettingsCtrl', SubscriptionDiscountSettingsCtrl)
  .controller('SubscriptionContentSetsCtrl', SubscriptionContentSetsCtrl)
  .controller('SubscriptionAccessoriesCtrl', SubscriptionAccessoriesCtrl)
  .controller('AddSubscriptionAccessoriesCtrl', AddSubscriptionAccessoriesCtrl)
  .controller('AddShowSetCtrl', AddShowSetCtrl)
  .controller('CustomizeClientAppsCtrl', CustomizeClientAppsCtrl)
  .controller('FeaturedCarouselCtrl', FeaturedCarouselCtrl)
  .controller('BannerCarouselCtrl', BannerCarouselCtrl)
  .controller('AddBannerBundleCtrl', AddBannerBundleCtrl)
  .controller('AddChannelSetCtrl', AddChannelSetCtrl)
  .controller('SubscriptionChannelListingCtrl', SubscriptionChannelListingCtrl)
  .controller('ChannelListingCtrl', ChannelListingCtrl)
  .controller('AddChannelGroupCtrl', AddChannelGroupCtrl)
  .controller('AddLiveEventSetCtrl', AddLiveEventSetCtrl)
  .controller('AddMultiSetCtrl', AddMultiSetCtrl)
  .controller('AddMultiSetItemsCtrl', AddMultiSetItemsCtrl)
  .controller('AddContentSetsCtrl', AddContentSetsCtrl)
  .controller('AddFeaturedRowItemsCtrl', AddFeaturedRowItemsCtrl)
  .controller('AddAddonsCtrl', AddAddonsCtrl)
  .controller('EditAddonCtrl', EditAddonCtrl)
  .controller('ViewContentSetCtrl', ViewContentSetCtrl)
  .controller('ShoppingCartSettingsCtrl', ShoppingCartSettingsCtrl)
  .controller('NewItemsPriceCtrl', NewItemsPriceCtrl)
  .controller('ContentSetsModalCtrl', ContentSetsModalCtrl)
  .controller('ContentItemIntersectionModalCtrl', ContentItemIntersectionModalCtrl)
  .controller('DiscountCampaignErrorModalCtrl', DiscountCampaignErrorModalCtrl)
  .controller('SubscriptionDiscountCampaignErrorModalCtrl', SubscriptionDiscountCampaignErrorModalCtrl)
  .controller('SubscriptionContentSetsModalCtrl', SubscriptionContentSetsModalCtrl)
  .controller('ShoppingCartCtrl', ShoppingCartCtrl)
  .controller('OrganizationLocalizationsCtrl', OrganizationLocalizationsCtrl)
  .controller('SetrixServerSettingsCtrl', SetrixServerSettingsCtrl)
  .controller('PaymentServicesCtrl', PaymentServicesCtrl)
  .controller('AddSubscriptionPlanCtrl', AddSubscriptionPlanCtrl)
  .controller('PartnerProductsCtrl', PartnerProductsCtrl)
  .controller('AddPartnerProductCtrl', AddPartnerProductCtrl)
  .controller('AddFreePartnerProductsCtrl', AddFreePartnerProductsCtrl)
  .controller('AddPaidPartnerProductsCtrl', AddPaidPartnerProductsCtrl)
  .controller('EditPaidPartnerProductCtrl', EditPaidPartnerProductCtrl)
  .controller('EditShoppingCartSettingsCtrl', EditShoppingCartSettingsCtrl)
  .controller('SubscriptionPartnerProductsCtrl', SubscriptionPartnerProductsCtrl)
  .controller('PromotionCtrl', PromotionCtrl)
  .controller('PreviewCtrl', PreviewCtrl)
  .controller('MenuPreviewCtrl', MenuPreviewCtrl)
  .controller('AddRowsCtrl', AddRowsCtrl)
  .controller('AddTermsCtrl', AddTermsCtrl)
  .controller('ModuleConfigurationCtrl', ModuleConfigurationCtrl)
  .controller('AddModuleSettingsCtrl', AddModuleSettingsCtrl)
  .service('alertLiteSvc', AlertLightSvc)
